// eslint-disable-next-line
const url = new URL(document.currentScript.src);
const index = url.href.lastIndexOf('/');
console.log('changing wpp for reactroot legacy', url);
__webpack_public_path__ = url.href.slice(0, index + 1);
